import KnBackToTopButton from '../../../shared/components/KnBackToTopButton.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import KnFormTitle from '../../../shared/components/KnFormTitle.vue';
import KnLocalAlert from '../../../shared/components/KnLocalAlert.vue';
import KnPagination from '../../../shared/components/KnPagination.vue';
import {
  fetchEvaluationPeriods,
  // fetchSubjectStudent,
  fetchSubjectStudents,
  // getNameOfSubjectHolder,
} from '../../helpers/syllabusOptions';
import KnAuthorizationGradeItem from '../KnAuthorizationGradeItem/KnAuthorizationGradeItem.vue';
import KnAuthorizationGradeDetail from '../KAuthorizationGradeDetail/KnAuthorizationGradeDetail.vue';
import KnAuthorizationMiniGradeItem from '../KnAuthorizationMiniGradeItem/KnAuthorizationMiniGradeItem.vue';

import { paginationMixin } from '../../../shared/mixins/paginationMixin';
import {
  fetchGrades,
  fetchGradeDetails,
  GradeActions,
  updateGradeStatus,
} from '../../helpers/gradeOptions';
import { fetchQualificationStatus } from '../../../configuration/helpers/KnGroupsOptions';
import { mapState } from 'vuex';
import { getFullName } from '../../../shared/helpers/dataUtils';
import {
  getLocalData,
  removeLocalData,
  setLocalData,
} from '../../../income/helpers/incomeStorage';

export default {
  name: 'KnAuthorizationGradesPerStudent',
  components: {
    KnAuthorizationGradeDetail,
    KnAuthorizationGradeItem,
    KnAuthorizationMiniGradeItem,
    KnBackToTopButton,
    KnFormActionButtons,
    KnFormTitle,
    KnLocalAlert,
    KnPagination,
  },
  mixins: [paginationMixin],
  props: {
    entity: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentGroup: null,
      bkReadonly: false,
      valueDeterminate: 100,
      routerName: 'Autorizar Calificaciones',
      valid: true,
      grade: null,
      gradeDetails: [],
      gradeData: null,
      subjectStudents: [],
      /** Variables para alerta */
      errors: [],
      warnings: [],
      loading: false,
      showAlert: false,
      alertType: 'success',
      alertText: 'Registro exitoso',
      alertColor: null,
      /*********************** */
      loadingDetails: false,
      showDetail: false,
      gradeStatus: null,
      selectedEvaluationPeriod: null,
      periods: [],
      showEvaluationPeriod: true,
      students: [],
      subjectsNamesHeader: [],
      isSpecial: false,
    };
  },
  computed: {
    ...mapState(['institutionId']),
    isEntityNull() {
      return this.currentGroup === null;
    },

    groupName() {
      return !this.isEntityNull ? this.currentGroup.nombre_grupo : '';
    },
    periodFilter() {
      return !this.isEntityNull
        ? this.currentGroup && this.currentGroup.evaluationPeriodFilter
          ? this.currentGroup.evaluationPeriodFilter
          : null
        : null;
    },
    schoolYearFilter() {
      return !this.isEntityNull
        ? this.currentGroup.ciclo_escolar
          ? this.currentGroup.ciclo_escolar.dato
          : this.currentGroup.schoolYearFilter
          ? this.currentGroup.schoolYearFilter.dato
          : 'No especificado'
        : 'No especificado';
    },
    syllabusFilter() {
      return !this.isEntityNull
        ? this.currentGroup.plan_estudios
          ? this.currentGroup.plan_estudios.nombre
          : this.currentGroup.syllabusFilter
          ? this.currentGroup.syllabusFilter.nombre
          : 'No especificado'
        : 'No especificado';
    },
    currentSyllabus() {
      return !this.isEntityNull
        ? this.currentGroup.plan_estudios
          ? this.currentGroup.plan_estudios
          : this.currentGroup.syllabusFilter
          ? this.currentGroup.syllabusFilter
          : null
        : null;
    },
    getGroupOwnerName() {
      let groupOwner = null;
      if (!this.isEntityNull && this.currentGroup.profesores.length) {
        if (this.currentGroup.profesores.length === 1) {
          groupOwner = this.currentGroup.profesores[0];
        } else {
          groupOwner = this.currentGroup.profesores.find(
            (p) => p.titular_grupo
          );
        }
      }
      return groupOwner
        ? getFullName(groupOwner.datos_personales)
        : 'No especificado';
    },
    numberOfStudents() {
      return !this.isEntityNull ? this.currentGroup.alumnos.length : 0;
    },
  },
  async created() {
    this.setPaginationLimit(30);
    this.loading = true;

    this.currentGroup = this.entity;
    this.bkReadonly = false;

    this.isSpecial = this.entity ? this.entity.is_especial : false;

    this.alertText = 'Cargando... Por favor, espera';
    this.alertType = 'info';
    this.openAlert();
    const localData = getLocalData();

    if (localData) {
      Object.assign(this.$data, localData.data);
    } else {
      this.subjectsNamesHeader = await this.getSubjectsNamesHeader();
      await this.setEvaluationPeriods();
    }
    this.closeAlert();
    // console.log('Entity grupo', this.entity);
    setLocalData({
      data: this.$data,
      props: { entity: this.entity, readonly: false },
    });
    // console.log('entity', this.entity);
    // console.log('currentGroup', this.currentGroup);
  },
  updated() {
    // console.log('Hubo un cambio', this.$data);
    setLocalData({
      data: this.$data,
      props: { entity: this.entity, readonly: false },
    });
  },
  beforeRouteLeave(to, from, next) {
    // console.log('beforeLeave to: ', to, ' from: ', from);
    removeLocalData();
    next();
  },
  methods: {
    getFullName: getFullName,
    async setEvaluationPeriods() {
      if (this.showEvaluationPeriod) {
        const { ok: okEvaluationPeriod, data: dataEvaluationPeriod } =
          await fetchEvaluationPeriods({
            institutionId: this.institutionId,
            systemStatus: true,
            startDate:
              !this.isEntityNull && this.currentGroup.ciclo_escolar
                ? this.currentGroup.ciclo_escolar.fecha_inicio
                : null,
            endDate:
              !this.isEntityNull && this.currentGroup.ciclo_escolar
                ? this.currentGroup.ciclo_escolar.fecha_fin
                : null,
            limit: 100,
          });

        this.periods = okEvaluationPeriod ? dataEvaluationPeriod : [];
      }
    },
    async getEvaluations() {
      if (!this.isEntityNull) {
        this.loading = true;
        this.students = this.currentGroup.alumnos;
        for (const student of this.students) {
          for (const subject of student.materias) {
            const { ok, data, message } = await fetchSubjectStudents({
              studentId: student.id,
              subjectTeacherId: subject.id,
              systemStatus: true,
              limit: this.pagination.limit,
              offset: this.pagination.offset,
            });
            if (ok) {
              for (const subjectstudent of data) {
                // console.log('subjectstudent', subjectstudent);

                const { ok: okGrade, data: dataGrade } = await fetchGrades({
                  institutionId: this.institutionId,
                  materiaAlumno: subjectstudent.id,
                  periodo: this.selectedEvaluationPeriod
                    ? this.selectedEvaluationPeriod.id
                    : null,
                  statusToExclude: 'borrador',
                  systemStatus: true,
                  limit: 100,
                });
                if (okGrade) {
                  subject.grade = dataGrade.length ? dataGrade[0] : null;
                }
              }
            } else {
              console.log('No se pudieron obtener materiasAlumnos', message);
            }
          }
        }
        // console.log('Alumnos con calificacion?', this.students);

        this.loading = false;
      }
    },
    async getSubjectsNamesHeader() {
      let subjects = [];
      let allSubjectsTeacher = [];
      const subjectsTeachers = this.isEntityNull
        ? []
        : this.currentGroup.materia_profesor;
      if (this.isSpecial) {
        allSubjectsTeacher = subjectsTeachers;
      } else if (this.currentSyllabus) {
        const subjectsOfSyllabus = [
          ...this.currentSyllabus.materias_curriculares,
          ...this.currentSyllabus.materias_extracurriculares,
        ];
        allSubjectsTeacher = subjectsOfSyllabus.map((subject) => {
          const findedSubjectTeacher = subjectsTeachers.find(
            (st) => st.materia.id === subject.id
          );
          return findedSubjectTeacher
            ? findedSubjectTeacher
            : { id: null, materia: subject, profesor: null };
        });
      }
      // console.log('allSubjectsTeacher', allSubjectsTeacher);

      for (const subjectTeacher of allSubjectsTeacher) {
        // console.log('Materia revisar su titular', subject);
        // console.log('titular', subject.titular_materia);

        const { materia, profesor } = subjectTeacher;
        const personalData = profesor
          ? getFullName(profesor.datos_personales)
          : 'Sin asignar';

        const item = {
          ...subjectTeacher,
          nombre: materia.nombre,
          titular_grupo: personalData,
        };
        subjects.push(item);
      }
      return subjects;
    },
    getStudentSubject(subjects, subjectId) {
      // console.log('materia id', subjectId, 'materiaAlumno', subjects);
      const findedSubjectTeacher = subjects.find(
        (subject) => subject.materia.id === subjectId
      );
      // console.log('findedSubjectTeacher', findedSubjectTeacher);
      // console.log('grade', findedSubjectTeacher.grade);

      return findedSubjectTeacher ? findedSubjectTeacher : null;
    },

    async getGradeDetails(gradeId) {
      const { ok, data } = await fetchGradeDetails({
        gradeId: gradeId,
        systemStatus: true,
        limit: 50,
      });
      // console.log('');
      if (ok) {
        return data;
      }
      return [];
    },
    async getGradeStatus(name) {
      const { ok, data } = await fetchQualificationStatus({
        dato: name,
        systemStatus: true,
      });
      if (!ok) return null;
      const status = name.includes('rechaz')
        ? data.filter((s) => !s.dato.includes('eliminar'))
        : data;
      return data.length ? status[0] : null;
    },
    async runGradeAction(gradeData) {
      // console.log('informacion de calificacion', gradeData);
      this.alertText = 'Cambiando estatus. Por favor, espera';
      this.alertType = 'info';
      // this.loading = true;
      this.openAlert();
      // this.gradeData = gradeData;
      this.grade = gradeData;
      this.loadingDetails = true;
      let gradeStatus = null;
      switch (gradeData.action) {
        case GradeActions.PAUSE:
          gradeStatus = await this.getGradeStatus('revisión');
          break;
        case GradeActions.ACCEPT:
          gradeStatus = await this.getGradeStatus('aprob');
          break;
        case GradeActions.REJECT:
          gradeStatus = await this.getGradeStatus('rechaz');
          break;
        default:
          this.errors.push('Acción no permitida');
        // console.log('Accion no permitida');
      }
      if (gradeStatus) {
        const { ok, message } = await updateGradeStatus(
          this.grade.id,
          gradeStatus.id
        );
        if (ok) {
          // console.log(
          //   'Estatus de calificación actualizada exitosamente.',
          //   data
          // );
          await this.getEvaluations();
        } else {
          // console.log('Error al actualizar estatus de calificación. ', message);
          this.errors.push(message);
        }
      } else {
        this.errors.push('No se pudo encontrar el estatus de calificación');
      }
      if (this.errors.length) {
        this.alertType = 'error';
        this.alertText = this.errors.join(', ');
      } else {
        this.alertType = 'success';
        this.alertText = 'Estatus de calificación actualizada exitosamente';
      }
      // this.loading = false;
      this.loadingDetails = false;
    },
    async loadDetail(gradeData) {
      // console.log('informacion de calificacion', gradeData);
      this.loadingDetails = true;
      this.openDetail();
      this.grade = gradeData;
      this.gradeDetails = await this.getGradeDetails(this.grade.id);
      this.loadingDetails = false;
    },
    async toEdit(/*gradeData*/) {
      // console.log(gradeData);
    },
    openDetail() {
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
    },
    cancel() {
      this.$router.push({ name: this.routerName });
    },
    actionAlertBtn1() {
      if (this.alertType === 'success' || this.alertType === 'info') {
        this.returnToTable();
      } else {
        this.closeAlert();
      }
    },
    continueAdding() {
      this.closeAlert();
    },
    returnToTable() {
      this.$router.replace({ name: this.routerName });
    },
    openAlert() {
      this.showAlert = true;
    },
    closeAlert() {
      this.errors = [];
      this.showAlert = false;
    },
  },
};
